import { Stack, Box } from '@mui/joy';

export function MealIndicators({ mealsAssigned, isSelected }) {
  return (
    <Stack direction="row" gap={'2px'} sx={{ position: 'absolute', bottom: 7 }}>
      {mealsAssigned.filter(hasMeal => hasMeal).map((hasMeal, index) => (
        <Box
          key={index}
          sx={{
            width: 3,
            height: 3,
            borderRadius: '50%',
            backgroundColor: isSelected ? '#fff' :'var(--joy-palette-neutral-400)',
          }}
        />
      ))}
    </Stack>
  );
}

